import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type TSelectedItemState = {
	value: string;
};

const initialState: TSelectedItemState = {
	value: 'F.A.Q',
};

const selectedItemSlice = createSlice({
	name: 'selectedItem',
	initialState,
	reducers: {
		setSelectedItem: (state, action: PayloadAction<string>) => {
			state.value = action.payload;
		},
	},
});

export const { setSelectedItem } = selectedItemSlice.actions;

export default selectedItemSlice.reducer;
